import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div
          className="relative rounded-3xl overflow-hidden p-10 md:p-14 text-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=dark%20cinema%20auditorium%20with%20red%20velvet%20seats%20and%20dramatic%20stage%20lighting%2C%20warm%20golden%20glow%2C%20atmospheric%20movie%20theater%2C%20cinematic%20wide%20shot%2C%20elegant%20composition&width=1200&height=500&seq=cta-cinema-01&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-background-950/70"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              开启你的观影之旅
            </h2>
            <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-lg mx-auto leading-relaxed">
              小草影院每天为您精选最新院线大片和分类电影，动作片、喜剧电影、科幻大片一应俱全，立即开始观影吧！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                浏览全部电影
                <i className="ri-arrow-right-line ml-1.5"></i>
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-center border border-background-50/20"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}